import {makeStyles} from "@material-ui/core";

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
    },
    item: {
        flexBasis: '48%'
    },
    leftMiddleItem: error => ({
        flexBasis: '2%',
        borderTop: error ? `1px solid ${theme.palette.error.main}` : `1px solid ${theme.palette.secondary.main}`,
        borderBottom: error ? `1px solid ${theme.palette.error.main}` : `1px solid ${theme.palette.secondary.main}`,
        backgroundColor: theme.palette.common.white,
        position: 'relative',
    }),
    rightMiddleItem: error => ({
        flexBasis: '2%',
        borderTop: error ? `1px solid ${theme.palette.error.main}` : `1px solid ${theme.palette.secondary.main}`,
        borderBottom: error ? `1px solid ${theme.palette.error.main}` : `1px solid ${theme.palette.secondary.main}`,
        backgroundColor: theme.palette.common.white,
    }),
    exchangeIcon: {
        zIndex: '1',
        position: 'absolute',
        right: -1*theme.spacing(3),
        textAlign: 'center',
        top: theme.spacing(1),
        backgroundColor: theme.palette.common.white,
    },
    stacked: {
        marginTop: theme.spacing(2)
    }
}));

export default useStyles;




